import * as Yup from "yup";

export const importLeadInitialValues = {
    file: null,
};
